/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFAggregatedEnumerationResult } from './CRSFAggregatedEnumerationResult';
import {
    CRSFAggregatedEnumerationResultFromJSON,
    CRSFAggregatedEnumerationResultFromJSONTyped,
    CRSFAggregatedEnumerationResultToJSON,
} from './CRSFAggregatedEnumerationResult';
import type { CRSFEnumerationEvent } from './CRSFEnumerationEvent';
import {
    CRSFEnumerationEventFromJSON,
    CRSFEnumerationEventFromJSONTyped,
    CRSFEnumerationEventToJSON,
} from './CRSFEnumerationEvent';
import type { CRSFEnumerationStats } from './CRSFEnumerationStats';
import {
    CRSFEnumerationStatsFromJSON,
    CRSFEnumerationStatsFromJSONTyped,
    CRSFEnumerationStatsToJSON,
} from './CRSFEnumerationStats';
import type { CRSFIPDetails } from './CRSFIPDetails';
import {
    CRSFIPDetailsFromJSON,
    CRSFIPDetailsFromJSONTyped,
    CRSFIPDetailsToJSON,
} from './CRSFIPDetails';

/**
 * 
 * @export
 * @interface Enumerated
 */
export interface Enumerated {
    /**
     * 
     * @type {Array<CRSFEnumerationEvent>}
     * @memberof Enumerated
     */
    events: Array<CRSFEnumerationEvent>;
    /**
     * 
     * @type {Array<string>}
     * @memberof Enumerated
     */
    extra: Array<string>;
    /**
     * 
     * @type {{ [key: string]: CRSFIPDetails; }}
     * @memberof Enumerated
     */
    ip_details?: { [key: string]: CRSFIPDetails; };
    /**
     * 
     * @type {string}
     * @memberof Enumerated
     */
    query: string;
    /**
     * 
     * @type {CRSFEnumerationStats}
     * @memberof Enumerated
     */
    stats: CRSFEnumerationStats;
    /**
     * 
     * @type {number}
     * @memberof Enumerated
     */
    total: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof Enumerated
     */
    wildcards?: Array<string>;
}

/**
 * Check if a given object implements the Enumerated interface.
 */
export function instanceOfEnumerated(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "events" in value;
    isInstance = isInstance && "extra" in value;
    isInstance = isInstance && "query" in value;
    isInstance = isInstance && "stats" in value;
    isInstance = isInstance && "total" in value;

    return isInstance;
}

export function EnumeratedFromJSON(json: any): Enumerated {
    return EnumeratedFromJSONTyped(json, false);
}

export function EnumeratedFromJSONTyped(json: any, ignoreDiscriminator: boolean): Enumerated {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'events': ((json['events'] as Array<any>).map(CRSFEnumerationEventFromJSON)),
        'extra': json['extra'],
        'ip_details': !exists(json, 'ip_details') ? undefined : (mapValues(json['ip_details'], CRSFIPDetailsFromJSON)),
        'query': json['query'],
        'stats': CRSFEnumerationStatsFromJSON(json['stats']),
        'total': json['total'],
        'wildcards': !exists(json, 'wildcards') ? undefined : json['wildcards'],
    };
}

export function EnumeratedToJSON(value?: Enumerated | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'events': ((value.events as Array<any>).map(CRSFEnumerationEventToJSON)),
        'extra': value.extra,
        'ip_details': value.ip_details === undefined ? undefined : (mapValues(value.ip_details, CRSFIPDetailsToJSON)),
        'query': value.query,
        'stats': CRSFEnumerationStatsToJSON(value.stats),
        'total': value.total,
        'wildcards': value.wildcards,
    };
}

